// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/audio/:id/update\",\"regex\":\"^/audio/([^/]+)/update$\",\"paramNames\":[\"id\"]},{\"path\":\"/diary/:id/update\",\"regex\":\"^/diary/([^/]+)/update$\",\"paramNames\":[\"id\"]},{\"path\":\"/items/:id\",\"regex\":\"^/items/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/items/:id/update\",\"regex\":\"^/items/([^/]+)/update$\",\"paramNames\":[\"id\"]},{\"path\":\"/posts/:slug\",\"regex\":\"^/posts/([^/]+)$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/account\"},{\"path\":\"/audio/create\"},{\"path\":\"/check-email\"},{\"path\":\"/confirm-email\"},{\"path\":\"/contact\"},{\"path\":\"/diary/create\"},{\"path\":\"/items\"},{\"path\":\"/items/create\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/reset-password\"},{\"path\":\"/settings\"},{\"path\":\"/settings/update-password\"}]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://f5e999d997f816244fe64daa473d477c@o4508477803003904.ingest.de.sentry.io/4510047969607760',

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
